import { render } from "./StockBind.html?vue&type=template&id=5e5ab344"
import script from "./StockBind.ts?vue&type=script&lang=ts"
export * from "./StockBind.ts?vue&type=script&lang=ts"

import "./StockBind.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script